import { AppBar, Box, Drawer, IconButton, styled, Tab, Tabs, Toolbar } from '@mui/material'
import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ReactFlowProvider, useEdgesState, useNodesState } from '@xyflow/react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import ObjectComponents from './components/ObjectComponents';
import AddDPEFirst from './components/AddDPEFirst';
// import { getOpenDrawerLeft } from '../../../redux/drgMgtSlice';
import DPEManagement from '../../../components/DPEManagement';
import { getDpesRedux } from '../../../redux/dpesSlice';
import RegulatoryFiles from './components/RegulatoryFiles';
import RegulatoryDiagram from './components/RegulatoryDiagram';
import CreateRegulatoryDialog from './components/CreateRegulatoryDialog';
import EditRegulatoryDialog from './components/EditRegulatoryDialog';
import { useTheme } from '@emotion/react';
import { clearSelectedNodeRedux } from '../../../redux/selectedNodeSlice';
import CustomizedSnackbar from '../../../components/CustomizedSnackbar';
import PreviewPanel from './components/PreviewPanel';
import DRGSimulatorPanel from './components/DRGSimulatorPanel';
import { getOpenDrawerLeft, getOpenPreviewDRG, getOpenSimulatorDRG, setOpenDrawerRight, setOpenPreviewDRG, setOpenSimulatorDRG } from '../../../redux/layoutControlSlice';
import { getCurrentDRG, setCurrentDRG } from '../../../redux/drgMgtSlice';
import { setSelectedProfileSimulate, setSimulatorProfiles, setStatementHighlightPaths, setStatementOptions, setUsedParametersInDiagram } from '../../../redux/simulateMgtSlice';
import hasFlowChanged from '../../../utils/hasFlowChanged';
import { toRegulatoryDomainFile } from '../../../utils/regulatoryDiagramDomainState';

const drawerWidth = 270;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.only('xs')]: {
            marginLeft: 0,
        },
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ padding: '0px', height: "100%" }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabObjectFiles = memo(({ nodes, edges, setOpenCreate, statusUpdate, setStatusUpdate, openEdit, setOpenEdit }) => {
    return <RegulatoryFiles
        nodes={nodes}
        edges={edges}
        setOpenCreate={setOpenCreate}
        statusUpdate={statusUpdate}
        setStatusUpdate={setStatusUpdate}
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
    />;
});

const TabComponents = memo(() => {
    return <ObjectComponents />;
});

const getStorageJson = (key, fallback = null) => {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined || raw === '' || raw === 'undefined') {
        return fallback;
    }

    try {
        return JSON.parse(raw);
    } catch {
        return fallback;
    }
};

function RegulatoryPage() {

    const drgDraft = getStorageJson('drg-draft', {});

    const openDrawerLeft = useSelector(getOpenDrawerLeft);
    const regulatoryFile = useSelector(getCurrentDRG);
    const dispatch = useDispatch();
    const [value, setValue] = useState(0);
    const [openCreate, setOpenCreate] = useState(false);
    const [componentDisabled, setComponentDisabled] = useState(true);
    const [statusUpdate, setStatusUpdate] = useState(false);
    const [selectFile, setSelectFile] = useState();
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    // const [nodes, setNodes, onNodesChange] = useNodesState([]);
    // const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
    const dpes = useSelector(getDpesRedux);
    const [openAddDPE, setOpenAddDPE] = useState(false);
    const [isDPEUpdate, setIsDPEUpdate] = useState(false);
    const [firstCreate, setFirstCreate] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const theme = useTheme();
    const [consolePage, setConsolePage] = useState(0);
    // const [consoleOpen, setConsoleOpen] = React.useState(false); // Preview
    const openPreviewDRG = useSelector(getOpenPreviewDRG);
    const openSimulatorDRG = useSelector(getOpenSimulatorDRG);

    // Preview
    const [previewDRG, setPreviewDRG] = useState({});
    const [diagramPreview, setDiagramPreview] = useState({});

    const handlePreviewDataChange = (value) => {
        setPreviewDRG(value);
    };

    const handleDiagramPreviewChange = (value) => {
        setDiagramPreview(value);
    };

    const handleChange = (event, newValue) => {
        // console.log("Change tab: ", newValue);
        setValue(newValue);
    };

    const handleConsoleChange = (event, newValue) => {
        setConsolePage(newValue);
    };

    const handleCloseConsole = (e) => {
        // setConsoleOpen(false);
        const updatedNodes = nodes.map(node => (
            {
                ...node,
                selected: false,
                data: {
                    ...node.data,
                    showHandle: false
                }
            }
        ));

        const updatedEdges = edges.map(edge => (
            {
                ...edge,
                selected: false,
                style: { ...(edge.style || {}), strokeWidth: 1 }
            }
        ));

        setNodes(updatedNodes);
        setEdges(updatedEdges);
        dispatch(clearSelectedNodeRedux()); // เคลียร์ Data properties ที่ยังค้างล่าสุดไว้
        dispatch(setOpenPreviewDRG(false));
        dispatch(setOpenSimulatorDRG(false));
        dispatch(setSelectedProfileSimulate(undefined));
        dispatch(setSimulatorProfiles([]));
        dispatch(setUsedParametersInDiagram([]));
        dispatch(setStatementOptions([]));
        dispatch(setStatementHighlightPaths([]));
    };

    const handleHoverPreview = (e) => {

        const updatedNodes = nodes.map(node =>
            e.nodes.some(n => n === node.id)
                ? {
                    ...node,
                    // selected: true,
                    data: {
                        ...node.data,
                        highlighted: "highlighted",
                        showHandle: false
                    }
                }
                : {
                    ...node,
                    // selected: false,
                    data: {
                        ...node.data,
                        highlighted: "unhighlighted",
                        showHandle: false
                    }
                }
        );

        const updatedEdges = edges.map(edge =>
            e.edges.some(ed => ed === edge.id)
                ? {
                    ...edge,
                    selected: true,
                    style: {
                        ...edge.style,
                        stroke: '#1976d2',
                        strokeWidth: 1.5,
                        filter: 'drop-shadow(0px 0px 4px rgba(37, 99, 235, 0.8))', // เพิ่มเงาสีน้ำเงินเรืองแสง
                        opacity: 1,
                        zIndex: 1000
                    }
                }
                : {
                    ...edge,
                    selected: false,
                    style: {
                        ...edge.style,
                        stroke: '#b1b1b7', // (ตัวเลือกเสริม) บังคับกลับไปใช้สีเทา/สีเดิม
                        strokeWidth: 1,
                        filter: 'none',    // เอาเงาออก (เผื่อเคยมี)
                        opacity: 0.6,
                        zIndex: 0
                    }
                }
        );

        setNodes(updatedNodes);
        setEdges(updatedEdges);
    };

    const handleHoverLeavePreview = (e) => {
        setNodes(diagramPreview.nodes);
        setEdges(diagramPreview.edges);
    };

    useEffect(() => {
        const root_node = nodes.find((node) => {
            if (node.type === "root" && node.data.general_properties.resource !== undefined) {
                return true;
            } else {
                return false;
            }
        })
        if (regulatoryFile && root_node) {
            setComponentDisabled(false);
        } else {
            setComponentDisabled(true);
        }
    }, [regulatoryFile, nodes]);

    useEffect(() => {
        const selectFile = getStorageJson('regulatory-file', null);
        if (selectFile) {
            setSelectFile(selectFile);
        }
    }, []);

    useEffect(() => {

        const updatableNodesAndEdges = (updatable) => {
            setNodes((prev) =>
                prev.map((nd) => ({ ...nd, draggable: !updatable, selectable: !updatable, deletable: (nd?.root) ? false : !updatable }))
            );
            setEdges((prev) =>
                prev.map((ed) => ({ ...ed, reconnectable: !updatable, selectable: !updatable, deletable: !updatable }))
            );
        };

        updatableNodesAndEdges(openPreviewDRG);

    }, [openPreviewDRG])

    useEffect(() => {

        const updatableNodesAndEdges = (updatable) => {
            setNodes((prev) =>
                prev.map((nd) => ({
                    ...nd,
                    draggable: !updatable,
                    selectable: !updatable,
                    deletable: (nd?.root) ? false : !updatable,
                    selected: false,
                    data: {
                        ...nd.data,
                        showHandle: false
                    }
                }))
            );
            setEdges((prev) =>
                prev.map((ed) => ({
                    ...ed,
                    reconnectable: !updatable,
                    selectable: !updatable,
                    deletable: !updatable,
                    selected: false,
                }))
            );
        };

        updatableNodesAndEdges(openSimulatorDRG);

        if (openSimulatorDRG) {
            dispatch(setOpenPreviewDRG(false)); // ปิด Preview ถ้าเปิด Simulator
            dispatch(setOpenDrawerRight(false)); // ปิด Right Side ถ้าเปิด Simulator
            dispatch(setSelectedProfileSimulate(undefined));
            dispatch(setSimulatorProfiles([]));
        }

    }, [openSimulatorDRG, dispatch])

    useEffect(() => {
        if (selectFile?.regulatory_diagram_id) {
            const getLocalStorageFile = async (regulatory_diagram_id) => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatory/${regulatory_diagram_id}`);
                if (response.ok) {
                    const result = await response.json();
                    const normalizedResult = toRegulatoryDomainFile(result);
                    if (!drgDraft && normalizedResult) {
                        localStorage.setItem('drg-draft', JSON.stringify(normalizedResult));
                    } else if (normalizedResult?.regulatory_diagram_id === drgDraft?.regulatory_diagram_id) {
                        {
                            const drg_draft = {
                                nodes: drgDraft?.diagram.nodes || [],
                                edges: drgDraft?.diagram.edges || [],
                            }
                            const drg_fetch = {
                                nodes: normalizedResult?.diagram.nodes || [],
                                edges: normalizedResult?.diagram.edges || [],
                            }
                            const flowChanged = await hasFlowChanged(drg_draft, drg_fetch);
                            if (flowChanged) {
                                console.log("Changed in flow, using draft from localStorage");
                            }
                        };
                    } else {
                        localStorage.setItem('drg-draft', JSON.stringify(normalizedResult));
                    }
                    dispatch(setCurrentDRG(normalizedResult));
                    localStorage.setItem('regulatory-file', JSON.stringify(normalizedResult));
                } else {
                    console.error(response.status);
                }
            };
            getLocalStorageFile(selectFile.regulatory_diagram_id);
        }
    }, [selectFile]);

    useEffect(() => {
        if (!regulatoryFile || typeof regulatoryFile !== 'object') {
            return;
        }

        const timer = window.setTimeout(() => {
            const normalizedRegulatoryFile = toRegulatoryDomainFile(regulatoryFile);
            localStorage.setItem(
                'drg-draft',
                JSON.stringify(normalizedRegulatoryFile)
            );
        }, 1000);

        return () => window.clearTimeout(timer);
    }, [nodes, edges]);

    useEffect(() => {
        if (dpes && dpes.length === 0) {
            setOpenAddDPE(true);
        } else {
            setOpenAddDPE(false);
        }
    }, [dpes]);

    return (
        <section className="flex w-full overflow-hidden">
            {(openSimulatorDRG || openPreviewDRG) ? (
                <></>
            ) : (
                <Drawer
                    open={openDrawerLeft}
                    variant="persistent"
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', marginTop: "48px" },
                        zIndex: 1
                    }}
                >
                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        pointerEvents: (openPreviewDRG || openSimulatorDRG) ? 'none' : 'auto',
                        opacity: (openPreviewDRG || openSimulatorDRG) ? 0.5 : 1,
                        backgroundColor: (openPreviewDRG || openSimulatorDRG) ? 'rgba(200,200,200,0.2)' : 'transparent',
                        transition: 'all 0.3s ease'
                    }}>
                        <PanelGroup direction="vertical" autoSaveId>
                            <Panel defaultSize={70}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs
                                        onChange={handleChange}
                                        value={value}
                                    >
                                        <Tab
                                            label="Data Regulatory Graph Files"
                                            {...a11yProps(0)}
                                            sx={{
                                                padding: '5px',
                                                flex: 1,
                                                fontSize: 12
                                            }}
                                        />
                                        <Tab
                                            label="Object Components"
                                            disabled={componentDisabled}
                                            {...a11yProps(1)}
                                            sx={{
                                                padding: '5px',
                                                flex: 1,
                                                fontSize: 12,
                                                backgroundColor: componentDisabled ? 'rgba(200,200,200,0.2)' : '#fff',
                                            }}
                                        />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0} className="h-[calc(100%-49px)]">
                                    <TabObjectFiles
                                        nodes={nodes}
                                        edges={edges}
                                        setOpenCreate={setOpenCreate}
                                        statusUpdate={statusUpdate}
                                        setStatusUpdate={setStatusUpdate}
                                        openEdit={openEdit}
                                        setOpenEdit={setOpenEdit}
                                    />
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <TabComponents />
                                </TabPanel>
                            </Panel>
                            <PanelResizeHandle className="h-0.5 bg-slate-300 hover:bg-slate-400" />
                            <Panel defaultSize={30} minSize={20} maxSize={50}>
                                <DPEManagement isDPEUpdate={isDPEUpdate} setIsDPEUpdate={setIsDPEUpdate} />
                            </Panel>
                        </PanelGroup>
                    </Box>
                </Drawer>
            )}

            <Main open={openDrawerLeft}>
                <AddDPEFirst open={openAddDPE} setOpen={setOpenAddDPE} setIsDPEUpdate={setIsDPEUpdate} />
                <PanelGroup direction="vertical">
                    <Panel>
                        <ReactFlowProvider>
                            <RegulatoryDiagram
                                nodes={nodes}
                                setNodes={setNodes}
                                edges={edges}
                                setEdges={setEdges}
                                firstCreate={firstCreate}
                                setFirstCreate={setFirstCreate}
                                setStatusUpdate={setStatusUpdate}
                                handlePreviewDataChange={handlePreviewDataChange}
                                diagramPreview={diagramPreview}
                                handleDiagramPreviewChange={handleDiagramPreviewChange}
                            />
                        </ReactFlowProvider>
                    </Panel>
                    <CustomizedSnackbar />
                    {/* {consoleOpen && (<> */}
                    {(openPreviewDRG || openSimulatorDRG) && (<>
                        <PanelResizeHandle className='h-0.5 bg-slate-300 hover:bg-slate-400' />

                        {openPreviewDRG ? (
                            <PreviewPanel closePanel={handleCloseConsole} statements={previewDRG} onHover={handleHoverPreview} onHoverLeave={handleHoverLeavePreview} />)
                            : (
                                <DRGSimulatorPanel
                                    closePanel={handleCloseConsole}
                                    nodes={nodes}
                                />
                            )}

                    </>
                    )}

                </PanelGroup>
            </Main>
            <CreateRegulatoryDialog open={openCreate} setOpen={setOpenCreate} setStatusUpdate={setStatusUpdate} setFirstCreate={setFirstCreate} />
            <EditRegulatoryDialog open={openEdit} setOpen={setOpenEdit} setStatusUpdate={setStatusUpdate} />
        </section>
    )
}

export default RegulatoryPage